@let portCount = portList()?.length || 0;
<div
  class="port-plan-component"
  [class.mobile-port-plan]="appType === 'mobile'"
  [class.switch-more-than-48-ports]="eSwitchPortTypes.PORT_48 <= portCount"
  [class.two-rows-layout]="layout()?.type === ePortLayout.TWO_ROWS"
>
  @for (row of portRows(); track $index) {
    <div class="port-row">
      @for (port of row; track port.orderNumber) {
        <div
          class="select-none relative cursor-pointer child-item"
          (click)="selectedPort.emit(port.id===selectedPortId() ? null : port);"
          [class.archived]="port.childDevice.status === eEntityStatus.Archived"
          [class.error]="port.childDevice.incidentCountBySeverity.critical"
          [class.good]="!port.childDevice.incidentCountBySeverity.major && !port.childDevice.incidentCountBySeverity.minor && !port.childDevice.incidentCountBySeverity.critical"
          [class.paused]="port.childDevice.status === eEntityStatus.Paused"
          [class.unplugged]="port.childDevice.status === eEntityStatus.Unplugged"
          [class.warning]="(port.childDevice.incidentCountBySeverity.major || port.childDevice.incidentCountBySeverity.minor) && !port.childDevice.incidentCountBySeverity.critical"
        >
          @if (selectedPortId() === port.id) {
            <div class="absolute w-full h-full bg-black opacity-30 top-0 left-0 rounded"></div>
          }
          <span
            class="z-10 relative"
            [class.text-white]="selectedPortId() === port.id"
          >{{ port.orderNumber }}</span>
        </div>
      }
    </div>
  }
</div>
